<template>
  <div class="">
    <div class="content">
      <div class="title">基本信息</div>
      <div class="base clearfix">
        <div class="item">
          <div class="label">产品名称</div>
          <div class="value">{{ detailInfo.productCode }}/{{ detailInfo.productName }}</div>
        </div>
        <div class="item">
          <div class="label">支付时间</div>
          <div class="value">{{ detailInfo.payTime | cutString(16) }}</div>
        </div>
        <div class="item">
          <div class="label">订单号</div>
          <div class="value">{{ detailInfo.orderNo }}</div>
        </div>
        <div class="item">
          <div class="label">保单号</div>
          <div class="value">{{ detailInfo.policyNo }}</div>
        </div>
        <div class="item">
          <div class="label">保险期间</div>
          <div class="value">{{ detailInfo.startTime | cutString(10) }} 至 {{ detailInfo.endTime | cutString(10) }}</div>
        </div>
        <div v-if="detailInfo.policyUrl" class="item">
          <div class="label">电子保单</div>
          <div class="value">
            <a :href="detailInfo.policyUrl">
              <Button type="primary">下载电子保单</Button>
            </a>
          </div>
        </div>
        <div class="item">
          <div class="label">保险公司</div>
          <div class="value">{{ detailInfo.companyName }}</div>
        </div>
        <div class="item">
          <div class="label">业务类别</div>
          <div class="value">{{ detailInfo.sellType }}</div>
        </div>
        <div class="item">
          <div class="label">业务来源</div>
          <div class="value">{{ detailInfo.businessSource==1?'直营':'分销' }}</div>
        </div>
        <div class="item">
          <div class="label">保额</div>
          <div class="value">{{ detailInfo.coverage | number_format(2) }}元</div>
        </div>
        <div class="item">
          <div class="label">出单保费</div>
          <div class="value">{{ detailInfo.fee | number_format(2) }}元</div>
        </div>
        <div class="item">
          <div class="label">出单服务费</div>
          <div class="value">{{ detailInfo.commission | number_format(2) }}元</div>
        </div>
        <div class="item">
          <div class="label">出单业务员</div>
          <div class="value">{{ detailInfo.salemanName }}</div>
        </div>
        <div class="item">
          <div class="label">所属团队</div>
          <div class="value">{{ detailInfo.groupName }}</div>
        </div>
        <div class="item">
          <div class="label">所属机构</div>
          <div class="value">{{ detailInfo.organizationName }}</div>
        </div>
        <div class="item">
          <div class="label">付款方式</div>
          <div class="value">{{ payTypeMap[detailInfo.payType] }}</div>
        </div>
        <div class="item">
          <div class="label">保单状态</div>
          <div class="value">{{ statusMap[detailInfo.status] }}</div>
        </div>
        <template v-if="detailInfo.status == '-1'">
          <Divider />
          <div class="descLine"></div>
          <div class="item">
            <div class="label">退费金额</div>
            <div class="value">{{ detailInfo.refundFee | number_format(2) }}元</div>
          </div>
          <div class="item">
            <div class="label">退保生效时间</div>
            <div class="value">{{ detailInfo.refundStartTime  | cutString(16) }}</div>
          </div>
          <div class="item">
            <div class="label">退保类型</div>
            <div class="value">{{ refundTypeMap[detailInfo.refundType] }}</div>
          </div>
          <div class="item">
            <div class="label">预估扣减服务费</div>
            <div class="value">{{ detailInfo.reduceCommission | number_format(2) }}元</div>
          </div>
        </template>

      </div>
      <div class="title">投保人信息</div>
      <div class="base clearfix">
        <div class="item">
          <div class="label">投保人名称</div>
          <div class="value">{{ detailInfo.holderName }}</div>
        </div>
        <div class="item">
          <div class="label">投保人证件号</div>
          <div class="value">{{ detailInfo.holderCardNoMask }}</div>
        </div>
        <div class="item">
          <div class="label">投保人地址</div>
          <div class="value">{{ detailInfo.holderAddress }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  components: {
  },
  props: ['id'],
  mixins: [common],
  data() {
    return {
      tabVal: '1',
      statusMap: {
        '-1': '退保',
        '0': '终止',
        '1': '保障中'
      },
      refundTypeMap: {
        '1': '生效前退保 ',
        '2': '保障期间退保',
      },
      payTypeMap: {
        '1': '梧桐树代收',
        '2': '保司在线收银台',
        '3': '保司公对公收款',
      },
      detailInfo: {}
    };
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.$http({
        url: `/buz/grouppolicy/read/detail`,
        type: "GET",
        data: { id: this.id }
      }).then((res) => {
        this.detailInfo = res.data;
        this.$emit('request-success', res.data);
      })
    }

  }
};
</script>
<style lang="scss" scoped>
.tools-box {
  display: flex;
  justify-content: flex-end;
}

.content {
  .title {
    color: #333;
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: bold;

    &::before {
      content: '';
      display: inline-block;
      width: 2px;
      height: 14px;
      background-color: #333;
      margin-right: 10px;
      position: relative;
      top: 2px;
    }
  }

  .base {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 40px;
    .c-red {
      color: #e3461f;
    }

    .item {
      width: 25%;
      display: inline-block;
      flex: 0 0 25%;
      line-height: 3;
      display: flex;
      padding-right: 25px;

      >div {

        &.label {
          margin-right: 5px;
          flex: 0 0 100px;
        }
      }
    }
  }

  .descLine {
    border-bottom: 1px solid #eee;
  }
}
</style>
